import axios from "axios";
import { ApiResponse } from "@/types/api";

export type IpGeolocation = {
	ip_address: string;
	country: string;
	region: string;
	city: string;
};

export const getIpGeolocation = async (): Promise<
	ApiResponse<IpGeolocation | null>
> => {
	try {
		const response = await axios({
			url: `https://ipgeolocation.abstractapi.com/v1/?api_key=${process.env.ABSTRACT_API_KEY}`,
			method: "GET",
		});

		return {
			data: response.data,
			error: null,
		};
	} catch (e: any) {
		return {
			data: null,
			error: {
				message: "Unable to retrieve IP geolocation.",
			},
		};
	}
};
